import styled from 'styled-components';
import { FlexView } from '@cuemath/comps';

export const StateContainer = styled(FlexView)`
  height: 400px;
`;

export const PaginationRow = styled(FlexView)`
  height: 42px;
`;
